/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_Save_HintInputs */

const vi_einvoice_buyer_save_hint = /** @type {(inputs: Einvoice_Buyer_Save_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng và kho giữ nguyên. Lưu xong, hãy kiểm tra lại PDF trước khi xuất bản.`)
};

/**

* @param {Einvoice_Buyer_Save_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_save_hint = /** @type {((inputs?: Einvoice_Buyer_Save_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_Save_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_save_hint(inputs)
});